<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :disabled="readonly"
    min-width="290px"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <FieldDateInput
        v-model="dateValue"
        v-bind="$attrs"
        dense
        :name="name"
        @click:clear="clearDate"
      >
        <template #append>
          <div class="clickable" v-on="on" @click="openMenu()">
            <v-icon>mdi-calendar</v-icon>
          </div>
        </template>
      </FieldDateInput>
    </template>
    <v-card class="d-flex flex-column full-height pa-1" flat>
      <div class="d-flex flex-grom-1">
        <v-date-picker
          v-if="isCanSelectDate"
          v-model="selectDate"
          :allowed-dates="allowedDates"
          :max="max"
          :min="min"
          no-title
          @input="onSelectDate"
        >
        </v-date-picker>
      </div>
      <div
        v-if="isCanSelectTime"
        class="flex-grow-0 text-center time-container pb-2"
      >
        <v-autocomplete
          v-model="timeModel.hour"
          class="d-inline-block pa-2"
          dense
          hide-details
          :items="hourItems"
          outlined
          style="width: 100px"
        ></v-autocomplete>
        <span>:</span>
        <v-autocomplete
          v-model="timeModel.minute"
          class="d-inline-block pa-2"
          dense
          hide-details
          :items="minuteItems"
          outlined
          style="width: 100px"
        ></v-autocomplete>
        <span>:</span>
        <v-autocomplete
          v-model="timeModel.second"
          class="d-inline-block pa-2"
          dense
          hide-details
          :items="minuteItems"
          outlined
          style="width: 100px"
        ></v-autocomplete>
      </div>
      <div class="flex-grow-0 d-flex">
        <v-btn
          class="text-capitalize text-caption mr-2 font-weight-medium"
          depressed
          small
          text
          @click="close"
          >Đóng</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          class="text-capitalize text-caption mr-2 font-weight-medium"
          color="error"
          depressed
          small
          text
          @click="onDeleteDate"
          >Xoá</v-btn
        >
        <!-- <v-btn
          class="text-capitalize text-caption mr-2 font-weight-medium"
          color="primary"
          depressed
          small
          @click="saveDate"
          >Chọn</v-btn
        > -->
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import moment from 'moment'
import FieldDateInput from './field-date-input.vue'
export default {
  inheritAttrs: false,
  components: { FieldDateInput },
  props: {
    readonly: Boolean,
    value: {},
    type: {
      type: String,
      default: 'date',
      validator: function(value) {
        return ['date', 'datetime', 'time'].includes(value)
      },
    },
    allowedDates: { type: Function, default: () => true },
    min: {},
    max: {},
  },
  data: () => ({
    menu: false,
    selectDate: '',
    timeModel: { hour: '00', minute: '00', second: '00' },
    name: '',
  }),
  created() {
    this.name = Math.random()
  },
  watch: {
    value: {
      handler(value) {
        if (!value) return
        try {
          if (this.isCanSelectDate)
            this.selectDate = this.formatDateToPicker(value)
          if (this.isCanSelectTime) {
            let time = this.formatHourToPicker(value).toString()
            if (time.includes('Invalid date')) throw new Error('Invalid date')
            time = time.split(':')
            this.timeModel.hour = time[0] || '00'
            this.timeModel.minute = time[1] || '00'
            this.timeModel.second = time[2] || '00'
          }
        } catch (error) {
          console.error(error)
          this.selectDate = ''
          this.timeModel.hour = '00'
          this.timeModel.minute = '00'
          this.timeModel.second = '00'
          this.dateValue = ''
        }
      },
      immediate: true,
    },
  },
  computed: {
    hourItems() {
      return Array.from({ length: 25 }, (_, i) => i.toString().padStart(2, '0'))
    },
    minuteItems() {
      return Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'))
    },
    isCanSelectDate() {
      return ['date', 'datetime'].includes(this.type)
    },
    isCanSelectTime() {
      return ['time', 'datetime'].includes(this.type)
    },
    dateValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    typeFormatOuput() {
      if (this.type == 'date') {
        return 'DD/MM/YYYY'
      }
      if (this.type == 'datetime') {
        return 'DD/MM/YYYY HH:mm:ss'
      }
      if (this.type == 'time') {
        return 'HH:mm:ss'
      }
      return 'DD/MM/YYYY'
    },
    typeFormatInput() {
      if (this.type == 'datetime') {
        return 'YYYY-MM-DD HH:mm:ss'
      }
      if (this.type == 'time') {
        return 'HH:mm:ss'
      }
      return 'YYYY-MM-DD'
    },
  },
  filters: {},
  methods: {
    openMenu() {
      this.menu = !this.menu
      if (!this.menu && !this.value) {
        this.selectDate = ''
        this.timeModel.hour = '00'
        this.timeModel.minute = '00'
        this.timeModel.second = '00'
      }
    },
    formatToValue(value) {
      return value
        ? moment(value, this.typeFormatInput, true).format(this.typeFormatOuput)
        : ''
    },
    formatDateToPicker(value) {
      return value
        ? moment(value, this.typeFormatOuput).format('YYYY-MM-DD')
        : ''
    },
    formatHourToPicker(value) {
      return value ? moment(value, this.typeFormatOuput).format('HH:mm:ss') : ''
    },
    close() {
      this.menu = false
    },
    clearDate() {
      this.dateValue = ''
    },
    saveDate() {
      if (this.type == 'time') {
        this.dateValue = `${this.timeModel.hour}:${this.timeModel.minute}:${this.timeModel.second}`
      } else if (this.type == 'date') {
        let dateStr = `${this.selectDate}`
        this.dateValue = this.formatToValue(dateStr)
      } else {
        let dateStr = `${this.selectDate} ${this.timeModel.hour}:${this.timeModel.minute}:${this.timeModel.second}`
        this.dateValue = this.formatToValue(dateStr)
      }
    },
    onDeleteDate() {
      this.dateValue = ''
      this.close()
    },
    onSelectDate() {
      this.saveDate()
      this.close()
    },
  },
}
</script>

<style lang="scss">
.v-menu__content {
  .v-card {
    margin: 0 !important;
  }
}
</style>
